import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

export default function CheckoutButton({
  children,
  className,
  ...props
}: ComponentProps<"button">) {
  return (
    <button
      className={cn(
        "all-small-caps mx-auto mt-4 flex w-full place-content-center place-items-center border border-black bg-black px-6 py-3 text-center text-base uppercase tracking-wider text-white disabled:opacity-30 lg:max-w-120",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
